import React from 'react';
import CountUp from 'react-countup';
import cx from 'classnames';
import styles from './index.module.scss.js';

const TitleWithCurrency = ({
  title,
  amount,
  icon,
  counter,
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style }, title && /* @__PURE__ */ React.createElement("div", { className: styles.title }, title), /* @__PURE__ */ React.createElement("div", { className: styles.value }, typeof icon === "string" ? /* @__PURE__ */ React.createElement("img", { src: icon, alt: "currency" }) : icon, counter ? /* @__PURE__ */ React.createElement(
  CountUp,
  {
    preserveValue: true,
    useEasing: true,
    useGrouping: false,
    smartEasingThreshold: 10,
    start: 0,
    end: Number(amount),
    duration: 2,
    decimal: ".",
    decimals: 2
  }
) : amount));
TitleWithCurrency.displayName = "TitleWithCurrency";

export { TitleWithCurrency };
//# sourceMappingURL=index.js.map
